import React, { Component } from 'react';
import RatingStars5 from "../../../common/ratingStars5";
import { Tooltip } from 'reactstrap';
import InputText from "../../../pages/pageParts/inputForms/inputText";
import { revealPrompts, putToast } from "../../../api"

import moment from 'moment';
import '../../../index.scss';

class IndividualCharacteristics extends Component {
    constructor(props) {
        super(props);
        this.onCompetitorChange = this.onCompetitorChange.bind(this);
        this.receiveRating = this.receiveRating.bind(this);
        this.state = {
            loading: true,
            competitor: this.props.competitor,
            partner: this.props.partner,
            content: this.props.content ? JSON.parse(this.props.content) : {},
            options: this.props.options,
            promptStatus: this.props.promptStatus,
            rEvent: this.props.rEvent,
            tBallot: this.props.tBallot,
            isSubmitted: this.props.isSubmitted,
            tooltipOpen: {}
        }

        this.headerStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "6px 0px 0px 0px",
            margin:  "6px 0px 0px 0px",
            display: "block"
            }

        this.rankStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "10px 0px 0px 0px",
            backgroundColor: '#dddddd'
            }

        this.pointStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "0px 0px 10px 0px",
            backgroundColor: '#dddddd'
            }
    
        this.rankColStyle = {
            }
                
        this.labelStyle = {fontSize: "16px"};
        this.groupLabelStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "0px 0px 10px 0px",
            backgroundColor: '#dddddd'
        };

    }

    updateContents(rankOnly) {

        this.props.updateContents(this.state.competitor, JSON.stringify(this.state.content), rankOnly)
        if (this.state.partner) {
            this.props.updateContents(this.state.partner, JSON.stringify(this.state.content), rankOnly);
        }
    }

    onCompetitorChange(evt) {
        var id = evt.target.id
        if (id.startsWith("comments")) id = "comments";
        if (id.startsWith("title")) id = "title";
        if (id.startsWith("chr_comments")) id = id.substring(0,16);
        const val = evt.target.value
        let state = this.state;
        state.content[id] = val;
        this.setState(state);

        this.updateContents(false);
    }

    receiveRating = (id, rating) => {
        
        let state = this.state;
        state.content[id] = rating;
        state.content.points = this.state.options.reduce((a,b) => a + (state.content[b.key] || 0), 0)   
        this.setState(state);

        this.updateContents(false);
        
    };

    setRank(allPoints) {
        let state = this.state;
        if (allPoints) {
            const points = state.content.points;
            var rank = 1
            for(const oPoints of allPoints) {
                if (points < oPoints) rank++;
            }

            state.content.rank = rank;
            state.loading = false;
            this.setState(state);
            this.updateContents(true);
        }
    }

    componentDidMount() {
        this.setRank(this.props.allPoints)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.allPoints !== this.props.allPoints) {
            this.setRank(this.props.allPoints)
        }
        if(prevProps.promptStatus !== this.props.promptStatus) {
            this.setState({promptStatus: this.props.promptStatus})
        }
    }

    inputItem(label, value, id, onChange, placeholder, readOnly) {
        return (
            <div >
                <span style={{fontSize: "18px"}}>{label}:</span>
                <input  style={{margin: "10px", width: "85%", height: "34px", fontSize: "18px"}}
                  type='text'
                  id={id}
                  defaultValue={value}
                  onChange={onChange}
                  placeholder={placeholder} 
                  readOnly={readOnly}
                />
            </div>
        )
    }

    toggleToolTip(key) {
        const tooltipOpen = this.state.tooltipOpen;
        if (!tooltipOpen[key]) tooltipOpen[key] = false;
        tooltipOpen[key] = !tooltipOpen[key];
        this.setState({tooltipOpen});
    }
    
    revealPrompts(competitor) {

        const {tBallot} = this.state;
        const {tData, tRound, rEvent, tRoom} = tBallot.state;
        revealPrompts(competitor.userId, tRoom._id, rEvent.eventId, tRound._id, tData._id).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                putToast.info(d2.message);
                this.setState({ promptStatus: d2.rercPromptStatus });   
            }
        });
    }

    startSpeechTimer(ev) {
        ev.preventDefault();

        let state = this.state;
        state.content['startTime'] = moment();
        state.content['stopTime'] = null;
        this.setState(state);

        this.updateContents(false);
    }
    
    stopSpeechTimer(ev) {
        ev.preventDefault();

        let state = this.state;
        state.content['stopTime'] = moment();
        this.setState(state);

        this.updateContents(false);
    }

    render(){
        if (this.state.loading) { return null; }
        const {competitor, options, content, promptStatus, rEvent} = this.state;
        const space = 3;
        const charCount = content.comments ? content.comments.length : 0
        const showPromptButton = (rEvent.promptListId && rEvent.offeredCount > 0) && (!promptStatus || !promptStatus.revealedDate);
        const endPrepDate = content.startTime ? moment(content.startTime) : moment();

        if (promptStatus && promptStatus.finalPrompt && !content.title) content.title = promptStatus.finalPrompt;
        
        return (
            <div className="card">
                <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                    <div className="row">
                        <div className="col-9">
                            <label style={this.headerStyle}>{competitor.teamdisplayname ? competitor.teamdisplayname : competitor.displayname} {`(${moment(competitor.timeSlot).format('LT')})`}                             
                                {showPromptButton && <button style={{margin: "10px 12px", padding: "3px 6px"}} type="button" className="btn btn-info" onClick={()=>this.revealPrompts(competitor)}><i className="fa fa-list"></i>&nbsp;Reveal Prompts</button>}                            
                                <button style={{margin: "10px 12px", padding: "3px 6px"}} type="button" className="btn btn-info" onClick={(ev)=>this.startSpeechTimer(ev)}><i className="fa fa-clock"></i>&nbsp;{content.startTime && "Re-"}Start Speech Timer</button>
                                {content.startTime && !content.stopTime && <button style={{margin: "10px 12px", padding: "3px 6px"}} type="button" className="btn btn-info" onClick={(ev)=>this.stopSpeechTimer(ev)}><i className="fa fa-clock"></i>&nbsp;Stop Speech Timer</button>}
                            </label>
                                {promptStatus && !showPromptButton && <>
                                <p style={{display: "inline"}}><strong>Prompts: </strong>
                                    {`Revealed: ${moment(promptStatus.revealedDate).format('h:mm')}`}&nbsp;&nbsp;|&nbsp;&nbsp;
                                    {promptStatus.selectedDate ? `Selected: ${moment(promptStatus.selectedDate).format('h:mm')}` : "Prompt not selected yet"}&nbsp;&nbsp;|&nbsp;&nbsp;
                                    {promptStatus.offeredDate ? `Using Prep: ${moment(moment(endPrepDate).diff(moment(promptStatus.offeredDate))).format('m:ss')}` : "Prep not started yet"}&nbsp;&nbsp;|&nbsp;&nbsp;
                                </p>
                                </>
                                }
                            <p style={{display: "inline"}}><strong>Speaking Time: </strong>
                                {!content.startTime && <>{`Speech not started`}&nbsp;&nbsp;</>}
                                {content.startTime && !content.stopTime && <>{`${moment(moment().diff(moment(content.startTime))).format('m:ss')}`}&nbsp;&nbsp;</>}
                                {content.stopTime && <>{`${moment(moment(content.stopTime).diff(moment(content.startTime))).format('m:ss')}`}&nbsp;&nbsp;</>}
                            </p>
                        </div>
                        <div className="col-3" style={this.rankColStyle}>
                            <div className="float-right">
                            <label style={this.pointStyle}>Points: {content.points || 0}</label>
                                <label style={this.rankStyle}>Rank: {content.rank || 0}</label>
                            </div> 
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {this.inputItem("Title/Subject", content.title, "title_"+competitor.userId, this.onCompetitorChange, "", this.props.readOnly || (promptStatus && promptStatus.finalPrompt) )}
                        </div>
                    </div>

                    <hr style={{paddingTop: "0px", marginTop: "0px"}}/>

                    {options.filter(x=>x.group).map((optionGroup, index) => {
                        const gkeykey = optionGroup.key+'_'+competitor.userId;
                        return (
                            <>
                            <div className="row">
                                <div className="col-12 col-md-8 col-lg-6 col-xl-7">
                                    <div className="row">
                                        <div className="col-12 col-md-7">
                                            <label id={`ltt_${gkeykey}`} style={this.groupLabelStyle}>{optionGroup.group}:</label>
                                        </div>
                                        <div className="col-12 col-md-5">
                                            (1=poor, 2=fair, 3=good, 4=excellent, 5=superior)
                                        </div>                        
                                    </div>  

                                    {options.filter(x=>x.groupKey === optionGroup.key).map((option, index) => {
                                        const keykey = option.key+'_'+competitor.userId;
                                        return (
                                            <div className="row">
                                                <div className="col-12 col-md-7">
                                                    <label id={`ltt_${keykey}`} style={this.labelStyle}>{option.title}:</label>
                                                    {option.tip &&
                                                    <Tooltip placement="right" isOpen={this.state.tooltipOpen[option.key]} target={`ltt_${keykey}`} toggle={() => this.toggleToolTip(option.key)}>
                                                        {option.tip}
                                                    </Tooltip>
                                                    }                                
                                                </div>
                                                <div className="col-12 col-md-5">
                                                    <RatingStars5 readOnly={this.props.readOnly} id={keykey} space={space} rating={content[option.key]} receiveRating={(rating) => this.receiveRating(option.key,rating)}/> 
                                                </div>
                                            </div>
                                        )})
                                    }
                                </div>
                                <div className="col-12 col-md-4 col-lg-6 col-xl-5">
                                 Comments:
                                <InputText id={"chr_comments_"+gkeykey} value={content["chr_comments_"+optionGroup.key]} 
                                    onChange={this.onCompetitorChange} 
                                    placeholder="" readOnly={this.props.readOnly} rows={options.filter(x=>x.groupKey === optionGroup.key).length}/>
                                </div>                            
                            </div>
                            <hr />
                            </>
                        )})
                    }        

                    <hr style={{paddingTop: "0px", margin: "0px"}}/>
                    <div className="row">
                        <div className="col-12">
                            <InputText label="Reason for Ranking and other comments: (It is very helpful to the competitor if you enter at least 100 characters)" id={"comments_"+competitor.userId} value={content.comments} 
                            onChange={this.onCompetitorChange} 
                            labelSuffix={<span className={charCount >= 100 ? "font-success" : "font-danger"}>[{charCount}&nbsp;characters]</span>}
                            placeholder="" readOnly={this.props.readOnly}/>
                        </div>
                    </div>                                                                              
                </div>
            </div>    
        )
    }
}

export default IndividualCharacteristics;



